import { Conversation } from '@types'

export const RECOVERY_REASON_PREFIX = 'motivo de rechazo:'
export const RECOVERY_HOW_PREFIX = 'como recuperarlo:'

const getTimeValue = (date: string) => {
  const value = new Date(date || '').getTime()
  return Number.isNaN(value) ? 0 : value
}

const sortByDateDesc = (messages: Conversation[]) => {
  return [...messages].sort((a, b) => getTimeValue(b?.date) - getTimeValue(a?.date))
}

const getLatestRecoveryByPrefix = (conversation: Conversation[], prefix: string) => {
  const normalizedPrefix = prefix.toLowerCase()
  return (
    sortByDateDesc(
      (conversation || []).filter(
        message => message?.type === 'recovery' && message?.value?.toLowerCase().startsWith(normalizedPrefix)
      )
    )[0] || null
  )
}

export const getRecoveryConversationState = (conversation: Conversation[] = []) => {
  const recoveryReason = getLatestRecoveryByPrefix(conversation, RECOVERY_REASON_PREFIX)
  const recoveryHow = getLatestRecoveryByPrefix(conversation, RECOVERY_HOW_PREFIX)

  return {
    recoveryReason,
    recoveryHow,
    hasRecoveryReason: Boolean(recoveryReason),
    hasRecoveryHow: Boolean(recoveryHow),
    hasRecoveryComments: Boolean(recoveryReason && recoveryHow)
  }
}
